<template>
    <div
        class="flex flex-col items-center justify-center gap-3 px-6 py-14 text-center"
    >
        <div
            class="flex h-12 w-12 items-center justify-center rounded-full bg-indigo-500/10 text-indigo-500 dark:text-indigo-400"
        >
            <svg
                class="h-6 w-6"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                aria-hidden="true"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661l-2.797-9.086a2.25 2.25 0 0 0-2.151-1.588H7.298a2.25 2.25 0 0 0-2.151 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z"
                />
            </svg>
        </div>
        <h2
            class="font-display text-lg font-semibold text-gray-900 dark:text-white"
        >
            {{ title }}
        </h2>
        <p class="max-w-sm text-sm text-gray-500 dark:text-gray-400">
            {{ message }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "Sem registros aqui",
        },
        message: {
            type: String,
            default: "Não há registros para serem exibidos",
        },
    },
};
</script>
